import React, { useEffect, useState } from 'react';
import { Container, Row, Col, FormInput, FormGroup, Form, Button, FormSelect, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import Input from '../../../components/UI/Input/Input';
import Select from '../../../components/UI/Select/Select';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import AutoComplete from '../../../components/UI/AutoComplete/AutoComplete';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextArea from '../../../components/UI/TextArea/TextArea';
import ImageUploader from '../../../components/UI/ImageUploader/ImageUploader';
import PdfUploader from '../../../components/UI/PdfUploader/PdfUploader';

const UpdateAuthor = () => {
  const { submitHandler, back, loading, field } = useForm();
  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('author.title.update')} subtitle={t('author.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4 py-5 px-4">
              <form>
                <Row>
                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.name')} label={t('label.name')} {...field('name')} />
                  </Col>
                  <Col md="6">
                    <Select placeholder={t('placeholder.display')} label={t('label.display')} {...field('display')}>
                      <option value={true}>{t('author.show')}</option>
                      <option value={false}>{t('author.hide')}</option>
                    </Select>
                  </Col>
                  <Col md="6">
                    <ImageUploader
                      type="file"
                      accept="image/*"
                      {...field('image', 'file')}
                      module="author"
                      title={t('author.upload-image')}
                    />
                  </Col>
                  <Col md="12" className="d-flex justify-content-end">
                    <Button theme="info" disabled={loading} onClick={() => back()}>
                      {t('annuler')}
                    </Button>
                    &nbsp; &nbsp;
                    <Button theme="success" type="button" disabled={loading} onClick={() => submitHandler()}>
                      {t('update')}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UpdateAuthor;
